// extracted by css-extract-rspack-plugin
export default {"header":"header-10kaI","actions":"actions-1ptZr","description":"description-2wewD"};